/**
 * Schema of AlertaCarga
 * @author Simpli CLI generator
 */
import {cnpj, Schema} from 'simpli-web-sdk'
import DeliveryVehicleResponse from '@/model/response/DeliveryVehicleResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'

export default (model: DeliveryVehicleResponse): Schema => ({

  nome: {
    content: model.nome,
  },

  qtdSemOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdSemOcorrencia,
      },
    },
    textContent: model.qtdSemOcorrencia || '0',
  },

  qtdComOcorrencia: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdComOcorrencia,
      },
    },
    textContent: model.qtdComOcorrencia || '0',
  },

  qtdDevolvidas: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdDevolvidas,
      },
    },
    textContent: model.qtdDevolvidas || '0',
  },

  qtdTotal: {
    content: {
      component: RenderNumber,
      props: {
        number: model.qtdTotal,
      },
    },
    textContent: model.qtdTotal || '0',
  },

})
